import type { ReactNode } from "react";
import { Button, Dialog } from "@guestpilot/ui-kit";

/**
 * Every console write goes through one confirmation (BR-251: each action needs its own confirmation where destructive).
 * The confirm button says why it is unavailable until the form is valid.
 */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  danger,
  disabledReason,
  busy,
  onConfirm,
  onClose,
  children,
}: {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel: string;
  danger?: boolean;
  disabledReason?: string | undefined;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
}) {
  return (
    <Dialog
      open={open}
      title={title}
      {...(description ? { description } : {})}
      busy={busy ?? false}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant={danger ? "danger" : "primary"}
            disabledReason={busy ? "Saving…" : disabledReason}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {children}
    </Dialog>
  );
}

export const PLAN_OPTIONS = [
  { value: "starter", label: "Starter" },
  { value: "business", label: "Business" },
  { value: "scale", label: "Scale" },
  { value: "enterprise", label: "Enterprise" },
];
